/**
 * Shared constants for the Presentation mock-ups.
 *
 * Breakpoints mirror new-activecollab-front (Tailwind sm / md / lg / xl).
 */
export const BREAKPOINT = 640;
export const SM = "640px";
export const MD = "768px";
export const LG = "1024px";
export const XL = "1280px";
export const TRANSITION = "200ms ease";

/** Mock avatar background colours (stand-ins for real user avatars). */
export const AVATAR_COLORS = {
  yellow: "#F5B041",
  purple: "#A569BD",
  blue: "#5499C7",
  orange: "#E67E22",
  green: "#32B370",
  teal: "#48C9B0",
};
